const filtersHidden = [
  'q',
  'director',
  'trailer',
  'running_time',
  'media',
  'first_letter',
];

const filtersOrder = [
  'streaming_type',
  'availability',
  'in_stock_only',
  'name',
  'movie_title',
  'clip_title',
  'amateur_title',
  'performer_title',
  'scene_title',
  'studio_title',
  'category',
  'studio',
  'resolution',
  'languages',
  'price',
  'duration',
  'pornstar',
  'physical_medium',
  'gender',
  'body_type',
  'breast_size',
  'country',
  'ethnicity',
  'haircolor',
  'breast_type',
  'ass',
  'eyecolor',
  'age',
  'body_height',
  'body_weight',
];

const filtersWithAlphabeticallySortedOptions = [
  'category',
  'studio',
  'country',
  'languages',
];

const filtersInitiallyOpen = [
];

const defaultFilters = {
  in_stock_only: '0',
  pictures: '1',
};

const skipCountFilters = [
  'q',
  'filter[media]',
  'filter[streaming_type]',
  'filter[order]',
  'order',
  'utm_campaign',
  'utm_source',
  'utm_medium',
  'utm_content',
  'bid',
  'coupon',
];

module.exports = {
  filtersHidden,
  filtersOrder,
  filtersWithAlphabeticallySortedOptions,
  filtersInitiallyOpen,
  defaultFilters,
  skipCountFilters,
};



// WEBPACK FOOTER //
// ./src/_utilities/filters.js